var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailOutgoing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66659 10.6344C7.66659 10.4077 7.69325 10.1877 7.72659 9.96773H1.66659V3.30107L6.99992 6.6344L12.3333 3.30107V6.6944C12.8133 6.7744 13.2599 6.94107 13.6666 7.1744V1.96773C13.6666 1.2344 13.0666 0.634399 12.3333 0.634399H1.66659C0.933252 0.634399 0.333252 1.2344 0.333252 1.96773V9.96773C0.333252 10.7011 0.933252 11.3011 1.66659 11.3011H7.72659C7.69325 11.0811 7.66659 10.8611 7.66659 10.6344ZM12.3333 1.96773L6.99992 5.30107L1.66659 1.96773H12.3333ZM12.3333 12.6344V11.3011H9.66659V9.96773H12.3333V8.6344L14.3333 10.6344L12.3333 12.6344Z",
    fill: "#1677FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailOutgoing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-outgoing.f779e8fce8643cc47b3bf32b5d489caf.svg";